import {
  listen as wappRunnerListen,
  WappRunnerEvent,
} from 'weblite-web-wapprunner'
import { disableWappNoSleep } from '$func/no-sleep'
import { WappPanel, OverlayWappPanel } from './wapp-panels'
import {
  CallWappPanel,
  KoolehWappPanel,
  VitrineWappPanel,
  JaryanWappPanel,
  MavakebWappPanel,
  RahkarWappPanel,
  CourseVitrineWappPanel,
} from './static-wapp-panels'

WappPanel.listenToHistoryEvents()

OverlayWappPanel.listenToHistoryEvents()
KoolehWappPanel.listenToHistoryEvents()
JaryanWappPanel.listenToHistoryEvents()
MavakebWappPanel.listenToHistoryEvents()
RahkarWappPanel.listenToHistoryEvents()
VitrineWappPanel.listenToHistoryEvents()
CourseVitrineWappPanel.listenToHistoryEvents()
CallWappPanel.listenToHistoryEvents()

wappRunnerListen((e, sessionId) => {
  if (e === WappRunnerEvent.UNMOUNT) {
    disableWappNoSleep(sessionId)
  }
})
